import React from 'react'
import LandingGradient from '../landing/landingGradient'
import Breadcrumbs from '../../breadcrumbs'

function PageTitle({title, crumbs, description, type}) {
  return (
    <section className={`header-section`}>
      {type !== 'white' && <LandingGradient />}
      <div className={`custom-content`}>
        {crumbs && <Breadcrumbs path={crumbs}/>}
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
    </section>
  )
}

export default PageTitle